import { render, staticRenderFns } from "./View16.vue?vue&type=template&id=6afaf5be&scoped=true&"
import script from "./View16.vue?vue&type=script&lang=js&"
export * from "./View16.vue?vue&type=script&lang=js&"
import style0 from "./View16.vue?vue&type=style&index=0&id=6afaf5be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afaf5be",
  null
  
)

export default component.exports